module.exports = __webpack_public_path__ + "img/thumbnail_BrownThroatedSloth_f_normal.d3a71212.png";